import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieReplacementComponent } from './cookie-replacement.component';
import { DaButtonModule } from '../da-button/da-button.module';

@NgModule({
    declarations: [CookieReplacementComponent],
    imports: [CommonModule, DaButtonModule],
    exports: [CookieReplacementComponent]
})
export class CookieReplacementModule {}
